import { css, styled } from 'styled-components';

export const lightModal = css`
  background-color: ${(props) => props.theme.colors.white};
  color: ${(props) => props.theme.colors.oxfordBlue[100]};
`;
export const darkModal = css`
  background-color: ${(props) => props.theme.colors.oxfordBlue[100]};
  color: ${(props) => props.theme.colors.oxfordBlue[50]};
`;

export const ModalContent = styled.div<{ $colorVariant?: 'light' | 'dark' }>`
  ${(props) => {
    if (props.$colorVariant === 'dark') {
      return darkModal;
    }

    return lightModal;
  }}

  padding: 1.5rem 2rem;
  height: 100dvh;
  display: flex;
  flex-direction: column;

  @media (min-width: ${(props) => props.theme.devices.tablet}) {
    position: relative;
    top: 2rem;
    max-height: calc(100dvh - 4rem);
    width: 80%;
    max-width: 60rem;
    margin: 0 auto;
    padding: 1.5rem;
    border-radius: 0.375rem;
    box-shadow: 0px 4px 10px rgba(49, 49, 49, 0.1);
  }
`;
